import { useState } from "react";
import FormInput from "./FormInput";
import searchIcon from "../assets/icons/search.svg";
import { useUser } from "../contexts/UserContext";
import LoggedInAdminData from "./LoggedInAdminData";
import "../styles/topbar.css"

const Topbar = () => {
	const { user } = useUser();

	const [showAdminData, setShowAdminData] = useState(false);

	const getInitials = (fullName: string) => {
		const names = fullName.split(' ');
		if (names.length > 1) {
			return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
		}
		return fullName.charAt(0).toUpperCase();
	};

	return (
		<>
			<div className="topbar">
				<div className="topbar-container">
					<div className="search_bar">
						<img src={searchIcon} alt="search" />
						<FormInput name="search" placeholder="Search anything" />
					</div>
					<div className="user_profile" onClick={() => setShowAdminData(true)}>
						<div className="user_initials">
							{user && getInitials(user.fullName)}
						</div>
						<div className="name_role">
							<span className="name">{user ? user.fullName : 'Guest'}</span>
							<span className="role">{user ? user.type : 'role'}</span>
						</div>
					</div>
				</div>
			</div>

			{showAdminData && (
				<LoggedInAdminData
					onHide={() => setShowAdminData(false)}
				/>
			)}
		</>
	)
};

export default Topbar